import { v4 as uuidv4 } from 'uuid';

export const generateIdV4 = (): string => uuidv4();

export const isValidIdV4 = (id: string): boolean => {
  const pattern =
    /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;
  return pattern.test(id);
};
